import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { SEARCH_CRM_BY_ID } from '../queries/crm';
export default function useGetCRMObjectByID({
  objectTypeId,
  skip,
  id,
  contentId
}) {
  const queryVariables = useMemo(() => {
    if (id !== undefined) {
      return {
        objectTypeId,
        id
      };
    } else {
      return {
        objectTypeId,
        contentId
      };
    }
  }, [id, objectTypeId, contentId]);
  const {
    loading,
    error,
    data,
    refetch
  } = useQuery(SEARCH_CRM_BY_ID, {
    variables: queryVariables,
    skip
  });
  return useMemo(() => {
    var _data$crmSearch$resul, _data$crmSearch;
    return {
      isLoadingCRMObject: loading,
      loadCRMObjectError: error,
      crmObject: (_data$crmSearch$resul = data === null || data === void 0 || (_data$crmSearch = data.crmSearch) === null || _data$crmSearch === void 0 ? void 0 : _data$crmSearch.results[0]) !== null && _data$crmSearch$resul !== void 0 ? _data$crmSearch$resul : null,
      refetchCRMObject: refetch
    };
  }, [loading, error, data, refetch]);
}